import React, { useState, useEffect, useRef , useContext } from 'react';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
// import certificate from "../../assets/images/company/certificate.png";
import certificate from "../../assets/images/company/Bumppy Payment SBI-01.png";
import certificate_signature from '../../assets/images/company/certificate_signature.png'
import './AgentCertificate.css'
import { GlobalContext } from '../Context/GlobalState';
import { BASE_URL_API } from '../utils/Constants';
import { API_ENDPOINTS } from '../utils/apiEndpoints';

export default function AgentCertificate() {
  const { Profileinfo, user, setTransactionLoaderState } = useContext(GlobalContext);

    const [profile, setProfile] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const certificateRef = useRef(null);

    useEffect(() => {
        const fetchProfile = async () => {
         
            setLoading(true);
            setError("");

            try {

                const myHeaders = new Headers();
                myHeaders.append("Content-Type", "application/json");


                const raw = JSON.stringify({
                    "UserId": user.ReferId
                });


                const requestOptions = {
                    method: "POST",
                    headers: myHeaders,
                    body: raw,
                    redirect: "follow",
                };


                const response = await fetch(
                    `${BASE_URL_API}${API_ENDPOINTS.get_retailer_profile_details}`,
                    requestOptions
                );

                const result = await response.json();

                if (result.status === "0") {
                    setProfile(result.data);

                } else {
                    setError(result.msg || "Failed to fetch data");

                }

            } catch (err) {

                const message = err?.message || "Network error occurred";
                setError(message);

            } finally {
                setLoading(false);
            }
        };
        fetchProfile();
    }, []);





    if (loading) return (
        <div className="flex justify-center items-center min-h-[400px]">
            <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-600"></div>
            <span className="ml-3 text-gray-600 font-medium">Loading Certificate...</span>
        </div>
    );

    if (error) return (
        <div className="max-w-md mx-auto mt-10 p-4 bg-red-50 border border-red-200 text-red-700 rounded-lg text-center">
            <p className="font-bold">Error</p>
            <p>{error}</p>
        </div>
    );

    return (


        <div className="ac-main-wrapper">
            <div
                ref={certificateRef}
                className="ac-cert-container"
                style={{ WebkitPrintColorAdjust: 'exact', printColorAdjust: 'exact' }}
            >

                <img
                    src={certificate}
                    alt="Certificate Frame"
                    className="ac-base-img"
                />


                {profile && (
                    <div className="ac-overlay-layer">


                        <div className="ac-header-title ac-center-box">
                            <h2>CERTIFICATE</h2>
                        </div>


                        <div className="ac-certify-section ac-center-box">
                            <div className='ac-flex-row-center'>
                                <p className="ac-text-normal ac-font-semibold">This is to certify that</p>
                                <p className="ac-text-normal">{profile.user_name}</p>
                                <p className="ac-text-normal">- [{profile.user_shop_name}]</p>
                                <p className="ac-text-normal">{profile.user_code}</p>
                                <p className="ac-text-normal">{profile.user_mobile}</p>
                            </div>
                        </div>


                        <div className="ac-subtext-section ac-center-box">
                            <div className='ac-flex-row-center'>
                                <p className="ac-text-small">
                                    is an authorized Business Correspondent Agent of the
                                    Business Correspondent of Bumppy Payments
                                </p>
                            </div>
                        </div>


                        <div className="ac-sig-box-left">
                            <p className="ac-sig-text-bold">Authorised Signature</p>
                            <p className="ac-sig-name">
                                {profile.user_name} [{profile.user_code}]
                            </p>
                        </div>


                        <div className="ac-sig-box-right">
                            <div className="ac-sig-img-wrap">
                                <img
                                    src={certificate_signature}
                                    alt="Signature"
                                    className="ac-sig-img"
                                />
                            </div>
                            <p className="ac-sig-text-bold" style={{ marginTop: '8px' }}>Authorised Signature</p>
                            <p className="ac-sig-name">Bumppy Payments Solutions</p>
                        </div>


                        <div className="ac-footer-section ac-center-box">
                            <p className="ac-footer-text">
                                Regd: Office: B-218, Ithum Tower Second Floor, Sector 62 Tel: +91 8130096177 <br />
                                Website: https://dashboard.bumppy.com | Email Id: info@bumppy.com | VALID TILL: 31 MARCH 2026 <br />
                                Terms & Conditions: *Valid date is subject to subsistence of the agreement with Bumppy Payments. as applicable to Business
                                Correspondent Agent and compliance with all the terms and conditions thereof.*
                            </p>
                        </div>


                        <div className="ac-print-btn-container ac-center-box">
                            <button
                                onClick={() => window.print()}
                                className="ac-print-btn"
                            >
                                Print
                            </button>
                        </div>

                    </div>
                )}
            </div>
        </div>
    );
}
